import React from 'react';
import Share from '../Share';
import SaveToFavoritesBuildingsButton from 'components/SavedHouses/SaveToFavoritesBuildingsButton';
import { FavoriteBuildingsResponse } from 'apolloClient/types/FavoriteBuilding';

interface BuildingHeaderProps {
  name: string;
  primaryAddress: string;
  buildingNameRef: React.RefObject<HTMLHeadingElement | null>;
  rentAndBuyRef: React.RefObject<HTMLElement | null>;
  buildingId: number;
  favoriteBuildings?: FavoriteBuildingsResponse;
}

export const BuildingHeader: React.FC<BuildingHeaderProps> = ({
  name,
  primaryAddress,
  buildingNameRef,
  rentAndBuyRef,
  buildingId,
  favoriteBuildings,
}) => (
  <section ref={rentAndBuyRef} className="relative section overflow-visible">
    <div id="RentAndBuy" className="absolute -top-28" />
    <div className="container text-m pt-[27px] md:pt-[8px] lg:pt-0">
      <div className="relative flex flex-row justify-between md:items-end">
        <div>
          <h1
            ref={buildingNameRef}
            className="px-px pt-1 uppercase font-sohneBreitBuch text-23-29-0.77 xl:text-24-47-0.8"
          >
            {name}
          </h1>
        </div>
        <div className="relative flex pt-px mb-2 space-x-2 text-16-26-0.3 lg:right-0 lg:-top-2 lg:relative md:mb-0">
          <div className="mt-0.5 md:mt-[12px] md:ml-[12px]  w-5 md:w-24 xl:w-[80px]">
            <SaveToFavoritesBuildingsButton
              visibility="hidden md:block"
              full
              iconWidth={15}
              iconHeight={18}
              buildingId={buildingId}
              userFavorites={favoriteBuildings}
            />
          </div>
          <div className="mt-0.5 md:mt-[12px] md:ml-[12px]  w-4 md:w-24 xl:w-[80px]">
            <Share visibility="hidden md:block" />
          </div>
        </div>
      </div>
      <p className="md:pt-[6px] lg:pt-[0] text-14-21-0.3 md:text-14-26-0.3 w-[90%]">
        {primaryAddress}
      </p>
    </div>
  </section>
);
